import {IHttpService} from "angular";
import {AccountBriefRecords, AccountIds} from "../types/AccountBriefRecord";
import {AccountId, AccountRecord} from "../types/AccountRecord";

export class AccountsService {

    public static id = "accountService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {

    }

    public async list(): Promise<AccountBriefRecords> {
        const url = "/tradefloor/api/accounts";
        const response = await this.$http.get<AccountBriefRecords>(url);
        return response.data;
    }

    public async ownedAccounts(): Promise<AccountIds> {
        const url = "/tradefloor/api/accounts/my-accounts";
        const response = await this.$http.get<AccountIds>(url);
        return response.data;
    }

    public async get(id: AccountId): Promise<AccountRecord> {
        const url = `/tradefloor/api/account/${id}`;
        const response = await this.$http.get<AccountRecord>(url);
        return response.data;
    }
}
